module.exports = __webpack_public_path__ + "static/media/arrow_left.7cb8fb75.svg";